<div>
    <app-page-title [title]="'Select An Online Test Date'"></app-page-title>
    <div
        class="row"
        *ngIf="showSelectSittingsTypeOption"
    >
        <app-sitting-type-selection
            [webDelivery]="webDelivery"
            [showPrivateSittings]="showPrivateSittings"
            [brandId]="brandId"
            (toggle)="toggleTestType($event)"
        ></app-sitting-type-selection>
    </div>
</div>

<div
    *ngIf="parentAccountSignedIn"
    class="row"
>
    <div class="col-md-4 form-group surveyQuestion">
        <label class="questionText">Select a country</label>
        <select
            [(ngModel)]="countryAbbr"
            (change)=getAllOnlineSittings()
            class="form-control"
            name="country"
        >
            <option
                [value]="undefined"
                disabled
            ></option>
            <option
                *ngFor="let country of countries"
                [value]="country.abbr"
            >{{country.name}}</option>
        </select>
    </div>
</div>

<div
    class="row"
    *ngIf="canDisplayError && availableSittings?.length == 0"
>
    <div class="col-md-8">
        <div class="alert alert-danger">
            No test sittings available at this time.
        </div>
    </div>
</div>

<div
    class="row"
    *ngIf="availableSittings?.length >= 1"
>
    <div class="col-md-8">
        <app-sitting-list
            [sittings]="showPrivateSittings? privateSittings: publicSittings"
            [isPrivate]="showPrivateSittings"
            [webDelivery]="true"
            [locationType]="locationType"
            [testTypeId]="testTypeId"
            [parentAccountSignedIn]="parentAccountSignedIn"
            (selectSitting)=finalizeSelectedSitting($event)
        >
        </app-sitting-list>
    </div>
</div>

<app-modal
    #startingModal
    title="{{startingModalTitle}}"
    body="{{startingModalBody}}"
>
</app-modal>
